/*
 * Clinical Slate skin flag — QLN Clinical Slate tranche T1 (web token export, DARK).
 *
 * ONE switch selects the token value-set (contract C2). The default (flag UNSET)
 * resolves the current SHIPPED values byte-identically; the flag ON resolves the
 * Clinical Slate PICKED value-set. There is NO customer-reachable UI setter for
 * this flag (I6): it is set only by a staging deploy env var or a test/probe
 * harness stamping the root attribute. Picked values are therefore DARK by
 * construction — present as inert CSS text in the bundle, rendered only where the
 * flag is deliberately set (staging evidence, T7). Prod activation is a separate
 * REVIEW-REQUIRED contract (I1); nothing here flips it.
 *
 * The single logical switch, two equivalent reads (recorded in the PR):
 *   - build-time  : REACT_APP_CLINICAL_SLATE=true  (staging deploy builds)
 *   - runtime/test: <html data-skin="clinical-slate">  (probe + parity harness)
 * The env read, when present, is authoritative; otherwise the root attribute is
 * consulted. Either being set enables the skin; neither → shipped default.
 *
 * Pure, dependency-free, SSR/jsdom-safe (guards `process` and `document`).
 */

export const SKIN_ATTR = 'data-skin';
export const SKIN_CLINICAL_SLATE = 'clinical-slate';

// True iff the Clinical Slate skin scope is selected. Default (both unset) = false.
export function isClinicalSlateSkin() {
  // Build-time env flag (staging deploys). Guarded for browsers without `process`.
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_CLINICAL_SLATE === 'true') {
    return true;
  }
  // Runtime root attribute (staging probe + parity harness). Guarded for non-DOM.
  if (typeof document !== 'undefined' && document.documentElement) {
    return document.documentElement.getAttribute(SKIN_ATTR) === SKIN_CLINICAL_SLATE;
  }
  return false;
}
